import * as React from 'react'
import styled from 'styled-components'
import HttpRequest from 'src/api/HttpRequest'
const contentDisposition = require('content-disposition');
import {
  ConfiguratorBox,
  HighlightInBox
} from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'
import { observer, inject } from 'mobx-react'
import { FuneralType } from 'src/resources'
import Link from 'src/components/atoms/input/buttons/Link'
import IconText from 'src/components/atoms/IconText'

const mailIcon = require('src/assets/envelope.png')
const whatsappIcon = require('src/assets/whatsapp.png')

@inject('confStore')
@observer
export class Success extends React.Component<StoreProps> {
  componentDidMount() {
    const { confStore } = this.props
    if (confStore.isOfferLoaded)
      HttpRequest.get(confStore.getOffer.offerDownloadUrl + "/", [
        {
          responseType: 'blob'
        }
      ]).then((response) => {
        // const offer = confStore.getOffer
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute(
          'download',
          contentDisposition.parse(response.headers['content-disposition']).parameters.filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
  }

  stringifyFuneralType = (ft: FuneralType) => {
    switch (ft) {
      case 'BURIAL':
        return 'Erbestattung'
      case 'CREMATION':
        return 'Feuerbestattung'
      case 'TREE_FUNERAL':
        return 'Baumbestattung'
      case 'SEA_FUNERAL':
        return 'Donaubestattung'
      case 'HOME_URN':
        return 'Feuerbestattung mit Aufbewahrung der Urne Zuhause'
      default:
        return 'ERROR'
    }
  }

  renderInstruct = () => {
    const { confStore } = this.props
    if (confStore.getOffer.orderConfirmed) {
      return (
        <HighlightInBox>
          <p>
            <strong>
              <i className='fas fa-check' /> Auftrag erfolgreich erteilt
            </strong>
          </p>
          <p>
            Wir haben Ihre Beauftragung erhalten und setzen bereits Schritte zur
            Durchführung. Wir danken für Ihr Vertrauen und beleiben mit Ihnen
            telefonisch oder per E-Mail in Kontakt.
          </p>
        </HighlightInBox>
      )
    }
    return (
      <Link to={`/planung/beauftragen/${confStore.getOffer.uuid}`}>
        Zur Online-Beauftragung
      </Link>
    )
  }

  render() {
    const { confStore } = this.props

    if (!confStore.isOfferLoaded) return null
    // Salesforce Integration: this command is not necessary.
    // There aren't delay of 5s like zoho integration
    //HttpRequest.get(confStore.getOffer.offerDownloadUrl)

    const offer = confStore.getOffer
    const greeting =
      offer.contactDetails.greeting === 'MR'
        ? 'Sehr geehrter Herr '
        : 'Sehr geehrte Frau '
    const funeralType = this.stringifyFuneralType(offer.funeralType)
    return (
      <>
        <ConfiguratorBox title='Bestätigung'>
          <p>
            {greeting}
            {offer.contactDetails.lastName},
          </p>
          <p>
            vielen Dank für Ihr Interesse an einer {funeralType} und die
            Erstellung der Bestattungsplanung.
          </p>
          <div className='product-long-desc'>
            <ul>
              <li>Ihre Anfrage wurde erfolgreich gespeichert</li>
              <li>
                Wir haben Ihnen eine E-Mail mit Ihrem Bestattungsangebot an
                folgende E-Mail Adresse geschickt:{' '}
                <u>{offer.contactDetails.email}</u>
              </li>
              <li>
                Ihr persönliches Angebot wird in Kürze heruntergeladen (
                <a href={offer.offerDownloadUrl} target='_blank'>
                  nochmal herunterladen
                </a>
                )
              </li>
            </ul>
          </div>
          <HighlightInBox>
            <p>
              <strong>Sie wollen Ihr Angebot weiter anpassen?</strong>
            </p>
            <p>
              Kehren Sie jederzeit einfach zu Ihrem Angebot zurück, um dieses
              nach Ihren Wünschen anzupassen. Gerne unterstützen wir Sie auch
              telefonisch oder per E-Mail.
            </p>
            <BackToConfigurator light to={`/planung/detailplanung/${offer.uuid}`}>
              Zurück zum Angebot
            </BackToConfigurator>
          </HighlightInBox>
        </ConfiguratorBox>
        <ConfiguratorBox title='Wie geht es jetzt weiter?'>
          <p>
            <strong>
              1. Lassen Sie sich telefonisch beraten (kostenfrei &
              unverbindlich)
            </strong>
          </p>
          <p>
            Wir nehmen uns Zeit für die Beratung. Telefonisch klären wir all
            Ihre Fragen ab, beraten Sie umfassend und gehen auf Ihre Wünsche
            ein. Das Telefonat hilft uns auch dabei externe Gebühren (z.B.
            Friedhofskosten) im Angebot zu ergänzen und Ihnen somit sämtliche
            Bestattungskosten transparent aufführen zu können.
          </p>
          <p>
            Bis zur Bestattung wird sich einer unserer Bestattungsexperten in
            unserem Team um Sie kümmern. Ihr persönlicher Ansprechpartner wird
            sich in Kürze bei Ihnen melden und mit Ihnen die Planung kostenfrei
            und unverbindlich weiterführen.
          </p>
          <p>
            <strong>2. Passen Sie Ihr Angebot flexibel an</strong>
          </p>
          <p>
            Um Ihr Angebot anzupassen, kehren Sie ganz einfach jederzeit zu
            Ihrer <a href={`/planung/detailplanung/${offer.uuid}`}>Angebotsseite</a>{' '}
            zurück. Gerne können Sie uns auch telefonisch oder per E-Mail
            kontaktieren, um Anpassungen vorzunehmen. Sobald Sie mit Ihrem
            Angebot zufrieden sind, können Sie uns mit der Durchführung der
            Bestattung beauftragen.
          </p>
          <p>
            <strong>3. Schließen Sie die Beauftragung ab</strong>
          </p>
          <p>Führen Sie die Beauftragung gleich hier bequem online durch:</p>
          {this.renderInstruct()}
          <p>
            Alternativ können Sie auch die Angebotsannahme sowie die Vollmacht
            am Ende des PDF-Angebots ausfüllen und unterschreiben. (
            <a href={offer.offerDownloadUrl} target='_blank'>
              Angebot nochmal herunterladen
            </a>
            ) Das unterschriebene Angebot schicken Sie ganz einfach als Foto
            oder eingescannt an:
          </p>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-evenly'
            }}>
            <IconText icon={mailIcon}>
              <a href='mailto:kontakt@benu.at'>E-Mail an kontakt@benu.at</a>
            </IconText>
            <IconText icon={whatsappIcon}>
              <a
                href={`https://wa.me/43800884404?text=Meine%20Vollmacht%20zum%20Angebot%20"${offer.orderId}"`}
                target='_blank'>
                WhatsApp an 0800884404
              </a>
            </IconText>
          </div>
          <p>
            Nach ausführlicher Beratung und Ihrer Beauftragung beginnen wir
            unmittelbar mit der Erbringung der gewünschten
            Bestattungsdienstleistung.
          </p>
        </ConfiguratorBox>
      </>
    )
  }
}

const BackToConfigurator = styled(Link)`
  margin: 7.5px auto;
  padding: 7.5px;
`

export default Success



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/Success.tsx